import type { TeamDTO } from '@/global/GlobalType';

export class Team {
  createTime?: string;
  creator?: string;
  id: string;
  teamAdminUser: string;
  teamDesc: string;
  teamName: string;
  teamType: number;
  teamUrl: string;
  lastOperator?: string;
  updateTime?: string;
  users: User[];

  constructor(team: TeamDTO) {
    Object.assign(this, team);
  }
}

export class User {
  brief: SString;
  id: SNumber | string;
  phone: SString;
  userAvatar: SString;
  userName: SString;
  userNamePinyin: SString;
  nickName: SString;
  nickNamePinyin: SString;
}

export class Comment {
  id: SNumber;
  content: SString;
  fromUserId: SNumber;
  fromUserName: SString;
  toUserid: SNumber;
  toUserName: SString;
  replyToId: SNumber;
  createTime: Date;
  updateTime: Date;
}

export class CommentAE {
  id: SNumber;
  targetId: SNumber;
  content: SString;
  fromUserId: SNumber;
  replyToId: SNumber;
}

export const DeliveryScaleTypeOptions = [
  { label: 'S', value: 0 },
  { label: 'M', value: 1 },
  { label: 'L', value: 2 },
  { label: 'XL', value: 3 },
];

export class OperationLog {
  id: SNumber;
  operatorId: SNumber;
  operatorName: SString;
  content: SString;
  logTime: Date;
}

export type SNumber = number | null;
export type SBoolean = boolean | null;
export type SString = string | null;
